const ITEMS = [
    "Mobile Platform Development",
    "Custom Software & Systems",
    "Hardware & Network Setup",
    "LAN Installation",
    "CCTV Security Systems",
    "Starlink Installation & Connectivity",
    "Technical Support",
];

export default function MarqueeBar() {
    const loop = [...ITEMS, ...ITEMS];
    return (
        <section
            data-testid="marquee-bar"
            aria-label="Core service areas"
            className="border-y border-slate-200 bg-navy py-5"
        >
            <div className="marquee-mask overflow-hidden">
                <div className="marquee-track">
                    {loop.map((item, i) => (
                        <span
                            key={i}
                            data-testid="marquee-item"
                            className="mx-8 inline-flex items-center gap-8 font-display text-sm font-semibold uppercase tracking-[0.14em] text-slate-300"
                        >
                            {item}
                            <span className="text-sky-400">✦</span>
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
